<template>
  <div>提交成功，正在跳转...</div>
</template>

<script>
import cookie from '@front-end/utils/lib/cookie';

export default {
  mounted() {
    cookie.set('Answered', 1);
    if (cookie.get('TTPS_TYPE') === 'B') {
      window.location.href = 'https://www.jin10.com/activitys/ttps-b/index.html#/video';
    } else {
      this.$router.replace('/video');
    }
  },
};
</script>
